import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

export const WeekIsBeforeCSS = () => (
  <Fragment>
    <Heading small>This week is before CCS started</Heading>
    You can only view ISS case claims here for weeks commencing on or after 2nd July 2018
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/iss-case-claims/views/before-ccs.jsx